export const SETTINGS_PAGE_HEADER = "Manage School Admin";

export const DIRECTORS_HEADING = "Current School Admin";
export const ADD_DIRECTOR_INSTRUCTIONS =
  `If you want a colleague (e.g., an assistant or principal) to have the same functionality as you, add their information under "Administrator Email."`;
export const ADD_DIRECTION_BUTTON_LABEL = "Add";
export const EMAIL_INPUT_LABEL = "Add School Admin Email";
export const DELETE_TOOLTIP_LABEL = "Delete";

export const DELETE_DIRECTOR_FAILURE = "Failed to delete school admin";
export const ADD_DIRECTOR_FAILURE = "Failed to add school admin";
export const VARSITY_COACH_INS = "Add your varsity head coaches here to manage their mid-season check-ins. They will then be able to add any junior coaches as needed.";


// WEBPACK FOOTER //
// ./src/pages/director/administrators/constants.ts